import { ActionCard } from '@playbooks/core/src/interfaces/ActionCard'

import { ActionCardsDbStore } from './actionCardsDbStore'
import { deleteFileQuestionsDb } from './dbService'
import { instance as autoLaunchedActionsDbStore } from './autoLaunchedActionsDbStore'
import { instance as funnelViewOpenedSeparatorsDbStore } from './funnelViewOpenedSeparatorsDbStore'

let isEnabled = true

const actionCardDbStore = new ActionCardsDbStore()

export function getIsStorageEnabled() {
  return isEnabled
}

export function setIsStorageActive(enable = true) {
  isEnabled = enable
}

export async function getLocalData(playbookId: string) {
  const key = getActionCardDataKey(playbookId)
  return await getLocalDataByKey(key)
}

export async function getLocalDataByKey(key: string) {
  const storageName = getStorageNameByKey(key)
  const data = localStorage.getItem(storageName)

  if (data) {
    // move data from local storage to IndexedDB
    const actionCardData = JSON.parse(data) as ActionCard
    await actionCardDbStore.save(key, null, actionCardData)
    localStorage.removeItem(storageName)
    return actionCardData
  } else {
    const data = await actionCardDbStore.get(key)
    return data ? data : null
  }
}

export async function saveLocalData(data: ActionCard, playbookId: string) {
  const key = getActionCardDataKey(playbookId)
  await actionCardDbStore.save(key, playbookId, data)
}

export async function saveLocalDataByKey(data: ActionCard, key: string) {
  await actionCardDbStore.save(key, null, data)
}

export async function clearLocalData(playbookId: string) {
  await actionCardDbStore.removeByPlaybook(playbookId)
  await funnelViewOpenedSeparatorsDbStore.remove(playbookId)
  await autoLaunchedActionsDbStore.remove(playbookId)
  await deleteFileQuestionsDb(playbookId)
}

export function getStorageName(playbookId: string) {
  const key = getActionCardDataKey(playbookId)
  return getStorageNameByKey(key)
}

function getStorageNameByKey(key: string) {
  return `lnd_actionCardData_${key}`
}

function getActionCardDataKey(playbookId: string) {
  const searchParams = new URL(location.href).searchParams
  const keys = [...searchParams.keys()].filter(key => key.startsWith('f_'))
  let key = `${playbookId}`
  if (keys.length) key += `_${keys.map(key => `${key.slice(2)}=${searchParams.get(key)}`).join('_')}`
  return key
}
